import { Feature, BusinessFormData } from "./types";

export const steps = [
  {
    label: "Business Information",
    icon: "business",
  },
  {
    label: "Subscription",
    icon: "card_membership",
  },
  {
    label: "Settings",
    icon: "settings",
  },
];

export const features: Feature[] = [
  {
    id: "has_inventory",
    title: "Inventory Management",
    description:
      "Track stock levels and manage products efficiently with real-time updates",
    icon: "inventory",
    benefits: [
      "Real-time stock tracking",
      "Low stock alerts",
      "Batch operations",
    ],
  },
  {
    id: "has_analytics",
    title: "Advanced Analytics",
    description:
      "Gain valuable insights with detailed reports and data visualization tools",
    icon: "analytics",
    benefits: ["Custom reports", "Sales forecasting", "Performance metrics"],
  },
  {
    id: "has_customer_loyalty",
    title: "Customer Loyalty",
    description:
      "Build customer relationships with rewards and personalized experiences",
    icon: "loyalty",
    benefits: ["Points system", "Reward tiers", "Customer profiles"],
  },
];

export const defaultValues: BusinessFormData = {
  business_name: "",
  owner: {
    email: "",
    first_name: "",
    last_name: "",
  },
  subscription: {
    plan: "basic",
    features: {
      max_users: 5,
      max_products: 100,
      max_locations: 1,
      has_inventory: false,
      has_analytics: false,
      has_customer_loyalty: false,
    },
  },
  settings: {
    timezone: "Asia/Bahrain",
    language: "en",
    currency: "BHD",
    tax_settings: {
      tax_included: true,
      default_tax_rate: 10,
    },
  },
};
